import { render, staticRenderFns } from "./VPSSecurityProfileUsernameEdit.vue?vue&type=template&id=061be426&scoped=true"
import script from "./VPSSecurityProfileUsernameEdit.vue?vue&type=script&lang=js"
export * from "./VPSSecurityProfileUsernameEdit.vue?vue&type=script&lang=js"
import style0 from "./VPSSecurityProfileUsernameEdit.vue?vue&type=style&index=0&id=061be426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061be426",
  null
  
)

export default component.exports